import React from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import useWindowSize from "./useWindowSize";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHome } from '@fortawesome/free-solid-svg-icons'
import { faCar } from '@fortawesome/free-solid-svg-icons'

const Header = () => {
    const {width} = useWindowSize();

    return (
        <Navbar
            bg="dark"
            variant="dark"
            expand="sm"
            className="bg-light justify-content-between"
        >
            <Navbar.Brand href="/">
                <img
                    sizes="(max-width: 1400px) 100vw, 1400px"
                    srcSet="
                        /images/logotipo_wciw5w_c_scale,w_200.png 800w,
                        /images/logotipo_wciw5w_c_scale,w_1400.png 1400w"
                    src="logotipo_wciw5w_c_scale,w_200.png"
                    alt="Elias Gomes Automoveis Logo"
                    className="d-inline-block align-top navbar-logotipo"
                    width={width > 768 ? "240":"200"}
                    height={width > 768 ? "50":"40"}
                />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
                <Nav>
                    <Nav.Item>
                        <Nav.Link href="/">
                            <FontAwesomeIcon icon={faHome}  className="mr-2"/>
                            Home
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link href="/lista-carros-usados-stand-pombal" eventKey="link-1">
                            <FontAwesomeIcon icon={faCar}  className="mr-2"/>
                            Lista de Veiculos
                        </Nav.Link>
                    </Nav.Item>
                </Nav>
            </Navbar.Collapse>
        </Navbar>
    );
}

export default Header;
